import { pbx_module_breadcrumbs } from './_module';

const index = pbx_module_breadcrumbs
  .extend('pbx.service-package.index')
  .add('pbx.breadcrumb.service-package.index', { name: 'pbx.service-package.index' });

export const pbx_packages_breadcrumbs = [index];
